<template>
  <div>
    <v-dialog
      v-model="openModal"
      max-width="640px"
      max-height="640px"
      @click:outside="closeModal"
      content-class="embed-modal"
      :fullscreen="isMobileBreakpoint"
      style="max-height: 89%"
    >
      <!-- has content -->
      <v-card
        v-if="!fetching"
        class="pt-7 pb-5 px-8"
        :style="{
          minHeight: isMobileBreakpoint ? '' : '512px',
          borderRadius: isMobileBreakpoint ? '8px' : '0',
        }"
      >
        <v-row :class="{ 'pa-4': isMobileBreakpoint }" no-gutters>
          <div style="width: 100%">
            <v-row no-gutters align="center">
              <v-col>
                <span class="body-bold-medium mb-2">
                  {{ $t('message.pages.video.buttonsPage.titleInsideButton') }}
                </span>
              </v-col>
              <v-col class="d-flex justify-end">
                <v-icon
                  @click="closeModal"
                  class="close-icon"
                  size="24"
                  color="grey"
                  style="cursor: pointer"
                >
                  mdi-close
                </v-icon>
              </v-col>
            </v-row>
            <span class="body-regular-smaller descriptionText mb-6">
              {{ $t('message.pages.video.buttonsPage.copyCodeExplain') }}
              <a
                target="_blank"
                type="secondary"
                :href="$t('message.pages.video.buttonsPage.copyCodeUrl')"
              >
                <span>
                  {{ $t('message.pages.video.buttonsPage.howToUse') }}
                </span>
                <v-icon size="12">mdi-open-in-new</v-icon>
              </a>
            </span>
          </div>
          <iframe
            v-if="!(selectedCta.metadata || {}).isCustomHtml"
            id="preview-iframe"
            style="width: 100%; border: none; background: white"
            class="mt-6"
            @load="setIframeCode"
          ></iframe>
          <iframe
            v-else
            :srcdoc="(selectedCta.metadata || {}).codeHtml"
            style="
              width: 91%;
              height: 100%;
              background: white;
              margin-left: 24px;
              border: none;
            "
          ></iframe>
          <v-tabs
            v-model="activeTab"
            @change="setOutsideBtnCode"
            class="custom-tabs mt-6"
            style="padding: 0px !important; font-size: 14px !important"
          >
            <v-tab>{{ $t('message.pages.video.buttonsPage.standart') }}</v-tab>
            <v-tab> HLS</v-tab>
          </v-tabs>

          <v-row no-gutters>
            <!-- embed -->
            <v-col cols="12" class="py-0 embed-textarea">
              <span class="body-regular-smaller">{{
                $t('message.pages.video.buttonsPage.codButton')
              }}</span>
              <v-textarea
                class="mt-4 embedInput"
                v-if="!fetching"
                v-model="textAreaContent"
                outlined
                hide-details
                dense
                readonly
                no-resize
                color="primary"
                style="font-size: 14px; margin-top: 3px !important"
                :class="{ 'v-input--is-focused': isFocused }"
                :rows="textareaRows"
                @focus="$event.target.select()"
              >
                <template v-slot:append>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        size="16"
                        class="mt-3 pandaCopy"
                        @mousedown.stop="focusIcon"
                        @click.stop="handleShowLink(textareaContent)"
                      >
                        panda-copy
                      </v-icon>
                    </template>
                    <span>
                      {{
                        $t(
                          `message.pages.videoEditModal.${
                            isCopied ? 'copied' : 'copyToClipboard'
                          }`
                        )
                      }}
                    </span>
                  </v-tooltip>
                </template>
              </v-textarea>
            </v-col>
          </v-row>
        </v-row>
      </v-card>

      <!-- is loading -->
      <v-card v-else>
        <v-row no-gutters style="height: 440px; max-height: 440px">
          <v-col
            class="d-flex align-center justify-center"
            style="height: 100%"
          >
            <loading-logo :value="200" />
          </v-col>
        </v-row>
      </v-card>
      <div class="py-6 pr-7 actionsBtns">
        <v-spacer></v-spacer>
        <base-btn @click="copyContent" type="primary">
          <span>{{ $t('message.pages.videoPlayerButtons.copyCode') }}</span>
        </base-btn>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import LoadingLogo from '@/components/LoadingLogo.vue'
import { ENV_CONFIG } from '@/config/envs'
import embedSelection from '@/utils/embedSelection.mixin.js'
import embedCode from '@/utils/embedCode.mixin.js'
import formatTimeMixin from '@/utils/formatTime.mixins.js'
import i18n from '@/translations/lang.js'
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'embedVideo',
  components: { LoadingLogo },
  props: {
    openModal: {
      type: Boolean,
    },

    showMenuEmbed: {
      default: false,
    },
    fetching: {
      default: true,
    },
    video: {
      type: Object,
    },
    selectedCta: {
      type: Object,
      require: true,
    },
  },
  mixins: [embedSelection, embedCode, formatTimeMixin],
  watch: {
    selectedCta: {
      handler(newValue) {
        this.cta = newValue
        this.setIframeCode()
      },
      deep: true,
    },
    cta: {
      handler() {
        if (this.cta) this.setOutsideBtnCode()
      },
    },
  },
  data: () => ({
    hasChanges: false,
    hlsEmbed: false,
    codeEmbed: false,
    activeTab: 0,
    srcEmbed: false,
    isExternalIdEmbed: false,
    showMenu: false,
    isLoading: false,
    isCopied: false,
    isFocused: false,
    textAreaContent: '',
    item: '',
    date: '',
    cta: {},
    pipScrollFollow: false,
    embedView: false,
    targetItems: [
      {
        val: 'standard',
        label: i18n.t('message.pages.videoPlayerButtons.targets.standard'),
      },
      {
        val: 'hls',
        label: i18n.t('message.pages.videoPlayerButtons.targets.hls'),
      },
    ],
  }),
  computed: {
    ...mapState('user', {
      planInfo: 'userPlanInfo',
      isMobileBreakpoint: 'isMobileBreakpoint',
    }),
    scriptUrl() {
      return ENV_CONFIG === 'production'
        ? 'https://player.pandavideo.com.br/api.v2.js'
        : 'https://player-staging.pandavideo.com.br/api.v2.js'
    },
    textareaContent() {
      return this.textAreaContent
    },
    textareaRows() {
      let row = '5'

      if (this.hlsEmbed) row = '4'
      if (this.codeEmbed || this.srcEmbed || this.isExternalIdEmbed) row = '3'

      return row
    },
  },
  async mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    setOutsideBtnCode() {
      if (
        this.cta.metadata.selectedButtonType === 'insideVideo' &&
        this.cta.metadata.appendWebsiteQueryParams
      ) {
        this.textAreaContent =
          `<script>if(!document.querySelector('script[src^="${this.scriptUrl}"]')){let s=document.createElement('script'); s.src='${this.scriptUrl}'; s.async=true; document.head.appendChild(s);}window.pandascripttag=window.pandascripttag || [];window.pandascripttag.push(function (){const p=new PandaPlayer('panda-${this.video.video_external_id}',{onReady(){p.setParentWindowUrl();}});})</scr` +
          'ipt>'
      } else if (this.cta.metadata.selectedButtonType === 'underVideo') {
        const targetCodes = {
          0:
            `<script>if(!document.querySelector('script[src^="${
              this.scriptUrl
            }"]')){let s=document.createElement('script'); s.src='${
              this.scriptUrl
            }'; s.async=true; document.head.appendChild(s);}window.pandascripttag=window.pandascripttag || [];window.pandascripttag.push(function (){const p=new PandaPlayer('panda-${
              this.video.video_external_id
            }',{onReady(){p.loadButtonInTime({fetchApi: true})${
              this.cta.metadata.appendWebsiteQueryParams
                ? ';p.setParentWindowUrl();'
                : ''
            }}});})</scr` + `ipt><div id="${this.cta.divId}"></div>`,
          1:
            `<script>document.addEventListener('readystatechange', ()=>{if (document.readyState !=='complete'){return;}let hlsLink='${
              this.video.video_hls
            }'; let pullzone=hlsLink.split('b-')[1].split('.')[0]; let id=hlsLink.split('.com.br/')[1].split('/')[0]; if (!document.querySelector('script[src^="${
              this.scriptUrl
            }"]')){let s=document.createElement('script'); s.src='${
              this.scriptUrl
            }'; s.async=true; document.head.appendChild(s);}window.pandascripttag=window.pandascripttag || []; window.pandascripttag.push(function(){const p=new PandaPlayer('iframe[src*="'+pullzone+'"][src*="'+id+'"]',{onReady(){p.loadButtonInTime({fetchApi: true});${
              this.cta.metadata.appendWebsiteQueryParams
                ? ';p.setParentWindowUrl();'
                : ''
            }}});})})</scr` + `ipt><div id="${this.cta.divId}"></div>`,
        }
        this.textAreaContent = targetCodes[this.activeTab]
      }
    },
    handleClickOutside() {
      this.isFocused = false
    },
    focusIcon(event) {
      event.preventDefault()
      this.isFocused = true
    },
    closeModal() {
      this.openModal = false
      if (!this.cta.metadata?.isCustomHtml) this.setIframeNull()
      this.$emit('update:openModal', false)
    },
    changesInEmbed() {
      this.hasChanges = true
    },
    copyContent() {
      this.hasChanges = false
      navigator.clipboard.writeText(this.textareaContent)
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: this.$t('message.pages.video.buttonsPage.copyMessage'),
        type: 'success',
      })
    },
    handleShowLink(item) {
      this.isCopied = true
      navigator.clipboard.writeText(`${item}`)
      setTimeout(() => {
        this.isCopied = false
      }, 3000)
      this.copyContent()
    },
    setIframeNull() {
      const iframe =
        document.getElementById('preview-iframe')?.contentWindow?.document ||
        document.getElementById('preview-iframe')?.contentDocument
      if (iframe) {
        iframe.open()
        iframe.write('')
        iframe.close()
      }
    },
    setIframeCode() {
      const iframe =
        document.getElementById('preview-iframe')?.contentWindow?.document ||
        document.getElementById('preview-iframe')?.contentDocument
      if (iframe) {
        iframe.open()
        iframe.write(this.cta.script)
        iframe.write(`<style>
                  body {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  }
                </style>`)
        iframe.close()
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/src/_tabsV2';

.custom-tabs {
  font-size: 14px !important;
  @include v-tabs;
}

.descriptionText {
  color: varFigma(neutral-40-light);
}

.embedInput ::v-deep .v-text-field__slot textarea {
  padding-right: 45px !important;
}

.actionsBtns {
  position: sticky;
  bottom: -1px;
  width: 100%;
  z-index: 10;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background: varFigma(neutral-100-white);
  border-top: 1px solid varFigma(neutral-95-lightest);
}

.v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}

::v-deep .embed-modal {
  background: varFigma(neutral-100-white) !important;
}

::v-deep .sizeInput.base-input.v-input[data-v-36a1b07e] input {
  font-weight: 400;
  font-size: 12px !important;
  color: var(--v-neutral-40-light-base);
}

::v-deep .v-textarea textarea {
  flex: none !important;
  width: 97% !important;
}

.pandaCopy {
  color: varFigma(neutral-60);
}
</style>

<style lang="scss">
.wrapText {
  word-break: break-word;
}

.custom-tabs .v-slide-group__prev {
  display: none !important;
  visibility: hidden !important;
}

.embed-textarea textarea {
  font-weight: 400;
  font-size: 12px !important;
  color: varFigma(neutral-40-light) !important;
}

// .timePicker .thumbnailTimePicker .ant-time-picker-input {
//   font-size: 12px;
//   padding: 0 8px;
//   color: varFigma(neutral-40-light);
// }

.v-text-field.sizeInput.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot,
.v-text-field.sizeInput.v-text-field--enclosed .v-text-field__details {
  padding: 0 8px;
}

.timePicker .ant-time-picker-icon,
.timePicker .ant-time-picker-clear {
  display: none;
}

.timePicker .thumbnailTimePicker {
  width: 52px;
}

.timePicker .darkThumbnailTimePicker {
  width: 52px;
}

.v-application--is-ltr .sizeInput.v-text-field .v-input__append-inner {
  margin-left: auto;
  padding-left: 0px;
}

.custom-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #3f404c;
  opacity: 0.8;
  z-index: 99;
}
.center-modal {
  position: fixed;
  border: none;
  max-height: 90vh;
  border-radius: 8px;
  top: 50% !important;
  left: 50% !important  ;
  transform: translate(-50%, -50%) !important;
  z-index: 300 !important;
}
</style>
